import { BigFormRow, FormRow, FormSection } from 'framework/ui/layout';
import { Permission } from 'infrastructure/security/authorization/davinciAuthorizationService';
import {
  UPDATE_EMPLOYEE_FAMILY_INFORMATION,
  ChildrenInput,
  FamilyMemberInput,
  FamilyMemberListInput,
  MaritalStatusInput,
} from 'domain/shared/employee';
import PrepopulationWrapper from 'domain/people/employee/prepopulation/PrepopulationWrapper';
import { FC } from 'react';

type FamilyUpdateSectionProps = {
  isGranted: (permission: Permission | Permission[], contextName?: string) => boolean;
};

const FamilyUpdateSection: FC<FamilyUpdateSectionProps> = ({ isGranted }) => {
  return (
    <FormSection title="Family" isVisible={isGranted(UPDATE_EMPLOYEE_FAMILY_INFORMATION)}>
      <FormRow>
        <MaritalStatusInput source="extendedInformation.maritalStatus" />
      </FormRow>
      <BigFormRow>
        <PrepopulationWrapper>
          <FamilyMemberListInput
            source="extendedInformation.other"
            inputTemplate={FamilyMemberInput}
            addText="Add family member"
          />
        </PrepopulationWrapper>
      </BigFormRow>
      <BigFormRow>
        <PrepopulationWrapper>
          <ChildrenInput source="extendedInformation.children" />
        </PrepopulationWrapper>
      </BigFormRow>
    </FormSection>
  );
};

export { FamilyUpdateSection };
